var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path10, _g9, _path11, _g10, _path12, _g11, _path13, _g12, _path14, _g13, _path15, _g14, _path16, _g15, _path17, _g16, _path18, _g17, _path19, _g18, _path20, _g19, _path21, _g20, _path22, _g21, _path23, _g22, _path24, _g23, _path25, _g24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrimotours = function SvgPrimotours(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F07800",
    d: "M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#primotours_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__b",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.96 4.045H4.046v31.912h31.912z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.003 34.59c8.046 0 14.588-6.543 14.588-14.59 0-8.046-6.542-14.588-14.588-14.588-8.047 0-14.589 6.542-14.589 14.589 0 8.046 6.542 14.588 14.589 14.588"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__c",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.96 20.001c0 8.822-7.135 15.956-15.957 15.956-8.821 0-15.956-7.134-15.956-15.956S11.182 4.045 20.003 4.045 35.959 11.18 35.959 20"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__d",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F07800",
    d: "M20.002 33.382c7.385 0 13.38-5.995 13.38-13.38s-5.995-13.38-13.38-13.38-13.38 5.994-13.38 13.38c0 7.385 5.994 13.38 13.38 13.38"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__e",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m20.392 21.186-.046.547.707-.114-.023.319-.707.114-.091 1.253c-.023.297.068.433.342.388.137-.023.205-.046.296-.068v.319a2.5 2.5 0 0 1-.433.136c-.228.046-.41 0-.524-.09-.114-.115-.16-.297-.137-.57l.091-1.277-.41.068.023-.319.41-.068.023-.433z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__f",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.948 22.303c-.069.866-.775 1.345-1.436 1.436-.73.114-1.254-.25-1.209-.98.046-.775.684-1.322 1.414-1.436.798-.137 1.276.274 1.23.98m-2.12.365c-.046.501.273.843.752.775.456-.069.843-.502.889-1.026.023-.387-.16-.843-.752-.752-.57.068-.866.57-.89 1.003"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__g",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.771 22.394c-.022.25-.022.456-.022.638l-.433.069v-.365h-.023a1.33 1.33 0 0 1-.912.57c-.433.068-.912-.069-.866-.867l.09-1.367.48-.069-.092 1.277c-.022.433.114.73.548.638a.86.86 0 0 0 .66-.501c.023-.069.046-.137.069-.228l.091-1.414.479-.068z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__h",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.662 21.3c.023-.274.023-.502.023-.73l.433-.068v.456h.023c.137-.342.456-.57.775-.638.045 0 .091 0 .137-.023l-.023.387c-.046 0-.091 0-.16.023a.83.83 0 0 0-.684.638c-.022.069-.022.137-.022.206l-.092 1.23-.478.069z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__i",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.325 22.19c.137.045.387.091.638.068.342-.045.524-.228.547-.433s-.114-.296-.456-.342c-.478-.068-.683-.273-.66-.547.022-.365.41-.73.98-.82.273-.046.5-.023.638.045l-.137.32a.94.94 0 0 0-.547-.046c-.296.045-.456.205-.456.387-.023.183.137.25.479.32.456.068.684.227.66.592-.022.41-.41.752-1.048.866-.296.046-.57.023-.752-.046z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__j",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.95 21.415s1.504-.205 1.754-1.505c0 0 .16-1.025-1.117-.729 0 0-.706.114-.911 1.368l-.388 3.76-1.14.183.365-4.012s.228-1.983 2.074-2.325c0 0 1.642-.319 2.189.89 0 0 .775 2.12-1.71 3.145 0 0-.934.342-1.185.387z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__k",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.814 17.54-1.185.181-.274 3.739 1.163-.183z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__l",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.59 17.471s.092.069.365 0c0 0 .912-.478 1.14-.638 0 0 1.185-.684 1.938-.046 0 0 1.914-1.39 2.735-.25 0 0 .319.228.137 1.436l-.137 2.142-1.277.228s.092-.319.137-1.276c0 0 .137-1.596.091-1.687-.045-.091-.068-.228-.228-.228 0 0-1.07.32-1.162.524l-.183 2.827-1.23.228s.273-2.758.228-2.918c-.046-.182-.114-.228-.32-.182 0 0-.478.068-1.094.524l-.182 2.781-1.208.182z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__m",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.335 18.155s-1.641.639-1.869 1.003l-.205 2.622-1.14.205.228-3.67s.091.045.479 0c0 0 1.527-.912 2.234-1.094z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__n",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.78 15.465s-1.87-.57-3.032 1.254c0 0-1.413 2.416 1.071 3.031 0 0 1.983.388 2.964-1.755 0 0 .843-1.846-1.003-2.53"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__o",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F07800",
    d: "M28.278 16.49s-1.003-.25-1.482.662c0 0-.706 1.23.297 1.595 0 0 1.094.205 1.527-.912.023-.022.365-1.048-.342-1.344"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__p",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30.557 14.69-.16-.432-.182.433z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__q",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30.625 14.714.228.25.182-.433"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__r",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30.898 15.352.433-.183-.433-.16z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__s",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__s)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30.876 15.42-.228.228.41.182"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__t",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30.215 15.693.182.434.16-.434z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__u",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30.145 15.648-.228-.228-.183.433"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__v",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__v)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m29.871 15.031-.41.16.41.16z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__w",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__w)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m29.92 14.964.228-.228-.433-.205"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__x",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__x)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.875 15.192a.467.467 0 0 1-.478.478.467.467 0 0 1-.479-.478c0-.274.228-.48.479-.48.25 0 .478.206.478.48"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "primotours_svg__y",
    width: 32,
    height: 32,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.047 20.001c0 8.822 7.135 15.956 15.956 15.956s15.956-7.134 15.956-15.956S28.824 4.045 20.003 4.045 4.047 11.18 4.047 20"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primotours_svg__y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D47519",
    d: "M30.399 15.739a.555.555 0 0 1-.547-.547c0-.297.25-.547.547-.547.296 0 .547.25.547.547-.023.296-.251.547-.547.547m0-.98a.433.433 0 0 0-.434.433c0 .25.183.433.434.433a.433.433 0 1 0 0-.867"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "primotours_svg__a",
    width: 39.715,
    height: 45.173,
    x: 0.146,
    y: 0.925,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.78
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.78
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937255 0 0 0 0 0.466667 0 0 0 0 0.00392157 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7216_208013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.34
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.17
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937255 0 0 0 0 0.466667 0 0 0 0 0.00392157 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_7216_208013",
    result: "effect2_dropShadow_7216_208013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.68
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.56
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937255 0 0 0 0 0.466667 0 0 0 0 0.00392157 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_7216_208013",
    result: "effect3_dropShadow_7216_208013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.241
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.95
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937255 0 0 0 0 0.466667 0 0 0 0 0.00392157 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_dropShadow_7216_208013",
    result: "effect4_dropShadow_7216_208013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.56
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937255 0 0 0 0 0.466667 0 0 0 0 0.00392157 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect4_dropShadow_7216_208013",
    result: "effect5_dropShadow_7216_208013"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect5_dropShadow_7216_208013",
    result: "shape"
  })))));
};
export default SvgPrimotours;